import { Component, Input, OnChanges, OnInit, SimpleChanges, inject } from '@angular/core';
import { NgxSpinnerService, NgxSpinnerModule } from 'ngx-spinner';
import { Entitlement } from 'src/app/modules/user-profile/models/entitlement';
import { ArmDatService } from 'src/app/modules/user-profile/services/arm-data-service';
import { RoleGroupEntitlement } from 'src/app/modules/user-profile/models/role-group-entitlement';
import { NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-compare-roles-details',
    templateUrl: './compare-roles-details.component.html',
    styleUrls: [
        '../../../../../../../../../src/assets/css/global-styles.scss',
        '../../../../../../../../../src/assets/css/ds-core.css',
        '../../../../../../../../../src/assets/css/ds-button.css',
        '../../../../../../../../../src/assets/css/ds-card.css',
        '../../../../../../../../../src/assets/css/ds-form.css',
        '../../../../../../../../../src/assets/css/ds-modal.css',
        '../../../../../../../../../src/assets/css/ds-step-indicator.css',
        '../../../../../../../../../src/assets/css/ds-tabs.css',
        '../../../../../../../../../src/assets/css/ds-tile.css',
        './compare-roles-details.component.scss',
    ],
    imports: [
    NgxSpinnerModule,
    FormsModule,
    NgClass
]
})
export class CompareRolesDetailsComponent implements OnInit, OnChanges {
  private armService = inject(ArmDatService);
  private spinner = inject(NgxSpinnerService);

  rolegroupEntitlement: Array<RoleGroupEntitlement> = [];
  // TODO: Skipped for migration because:
  //  Your application code writes to the input. This prevents migration.
  @Input() applicationKey: string;
  entitlementColumns: Array<Entitlement> = [];
  roleViewValue = 1;

  roleView: number = 1;
  orgKey: string;
  appkey: string;
  sysAppKey: string;

  ngOnInit(): void {
    this.roleView = 1;
    this.orgKey = sessionStorage.getItem('orgKey');
    this.sysAppKey = sessionStorage.getItem('applicationKey');
    this.getCompareRoles(this.orgKey, this.sysAppKey, this.roleView);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.orgKey = sessionStorage.getItem('orgKey');
    this.sysAppKey = sessionStorage.getItem('applicationKey');
    for (const propName in changes) {
      if (propName === 'applicationKey') {
        this.applicationKey = changes['applicationKey'].currentValue;
        if (!!this.applicationKey) {
          this.getCompareRoles(
            this.orgKey,
            this.applicationKey,
            this.roleView
          );
        }
      }
    }
  }

  getCompareRoles(orgKey, applicationName, roleView) {
    this.spinner.show();
    this.armService
      .roleGroupEntitlements$(orgKey, applicationName, roleView)
      .subscribe(
        (rolegroupEntitlement: Array<RoleGroupEntitlement>) => {
          this.rolegroupEntitlement = rolegroupEntitlement;
          this.roleGroupEntitlementGroups(this.rolegroupEntitlement);
          this.spinner.hide();
        },
        (error) => {
          this.spinner.hide();
        }
      );
  }

  roleGroupEntitlementGroups(rolegroupEntitlement) {
    this.entitlementColumns = rolegroupEntitlement[0]?.entitlements;
  }

  rowViewChange(roleViewValue: number) {
    this.roleViewValue = roleViewValue;
    this.orgKey = sessionStorage.getItem('orgKey');
    this.sysAppKey = sessionStorage.getItem('applicationKey');
    this.getCompareRoles(this.orgKey, this.sysAppKey, roleViewValue);
  }
}
